import { SidebarNames } from "../namesConstants/names";

export const sidebarRoutes = [
  {
    id: "accessControl",
    url: "/accessControl",
    name: "accessControl",
    title: SidebarNames.AccessControl,
    tapTitle: SidebarNames.AccessControl,
    icon: "GiPadlock",
    translate: SidebarNames.AccessControl,
    type: "item",
    show: false,
  },
  {
    id: "invitations",
    name: "invitations",
    url: "/invitations",
    title: SidebarNames.SidebarInvitations,
    tapTitle: SidebarNames.SidebarInvitations,
    icon: "HiOutlineMail",
    translate: SidebarNames.SidebarInvitations,
    type: "item",
    show: false,
    access: "Invitaciones",
  },
  {
    id: "applications",
    url: "/applications",
    name: "applications",
    title: SidebarNames.SidebarApplications,
    tapTitle: SidebarNames.SidebarApplications,
    icon: "RiListCheck2",
    translate: SidebarNames.SidebarApplications,
    type: "item",
    show: false,
    access: "Solicitudes",
  },
  {
    id: "assist",
    url: "/assist",
    name: "assist",
    title: SidebarNames.SidebarNameAssist,
    tapTitle: SidebarNames.SidebarNameAssist,
    icon: "AiOutlineSchedule",
    translate: SidebarNames.SidebarNameAssist,
    type: "item",
    show: false,
    childrends: [
      {
        id: "catalogs",
        url: "/catalogs",
        name: "catalogs",
        title: SidebarNames.SidebarCatalogs,
        tapTitle: SidebarNames.SidebarCatalogs,
        icon: "SiDatabricks",
        translate: SidebarNames.SidebarCatalogs,
        type: "item",
        open: false,
      },
      {
        id: "configuration",
        url: "/configuration",
        name: "configuration",
        title: SidebarNames.SidebarConfiguration,
        tapTitle: SidebarNames.SidebarConfiguration,
        icon: "IoSettingsOutline",
        translate: SidebarNames.SidebarConfiguration,
        type: "item",
      },
      {
        id: "incidences",
        url: "/incidences",
        name: "incidences",
        title: SidebarNames.SidebarIncidences,
        tapTitle: SidebarNames.SidebarIncidences,
        icon: "BsPersonFill",
        translate: SidebarNames.SidebarIncidences,
        type: "item",
      },
      {
        id: "operation",
        url: "/operation",
        name: "operation",
        title: SidebarNames.SidebarOperation,
        tapTitle: SidebarNames.SidebarOperation,
        icon: "",
        translate: SidebarNames.SidebarOperation,
        type: "item",
      },
      {
        id: "queries",
        url: "/queries",
        name: "queries",
        title: SidebarNames.SidebarQueries,
        tapTitle: SidebarNames.SidebarQueries,
        icon: "",
        translate: SidebarNames.SidebarQueries,
        type: "item",
      },
      {
        id: "justifyIncidence",
        url: "/justifyIncidence",
        name: "justifyIncidence",
        title: SidebarNames.JustifyIncidences,
        tapTitle: SidebarNames.JustifyIncidences,
        icon: "",
        translate: SidebarNames.JustifyIncidences,
        type: "item",
      },
    ],
    access: "Asistencia",
  },
  {
    id: "organizationChart",
    url: "/organizationChart",
    name: "organizationChart",
    title: SidebarNames.OrganizationChart,
    tapTitle: SidebarNames.OrganizationChart,
    icon: "GiOrganigram",
    translate: SidebarNames.OrganizationChart,
    type: "item",
    show: false,
    access: "Organigrama",
  },
  {
    id: "vacations",
    url: "/vacations",
    name: "vacations",
    title: SidebarNames.Vacations,
    tapTitle: SidebarNames.Vacations,
    icon: "GiVacations",
    translate: SidebarNames.Vacations,
    type: "item",
    show: false,
    access: "Vacaciones",
    childrends: [
      {
        id: "vacationBalances",
        url: "/vacation/balances",
        name: "vacationBalances",
        title: SidebarNames.VacationBalances,
        tapTitle: SidebarNames.VacationBalances,
        translate: SidebarNames.VacationBalances,
        type: "item",
      },
      {
        id: "vacationPolicies",
        url: "/vacation/policies",
        name: "vacationPolicies",
        title: SidebarNames.VacationPolicies,
        tapTitle: SidebarNames.VacationPolicies,
        translate: SidebarNames.VacationPolicies,
        type: "item",
      },
      {
        id: "leaveTypes",
        url: "/leave-types",
        name: "leaveTypes",
        title: SidebarNames.LeaveTypes,
        tapTitle: SidebarNames.LeaveTypes,
        translate: SidebarNames.LeaveTypes,
        type: "item",
      },
    ],
  },
];
